<template>
  <section class="video-section">
    <div class="video-frame">
      <div class="video-badges" aria-hidden="true">
        <span v-for="t in tags" :key="t" class="badge">{{ t }}</span>
      </div>
      <div class="video-broadcast">
        <span class="mark mark-left">CCTV 10</span>
        <span class="mark mark-right">腾讯视频</span>
      </div>
      <video
        class="video-player"
        controls
        playsinline
        :src="videoSrc"
        poster=""
      />
    </div>
  </section>
</template>

<script>
import videoSrc from "@/assets/image/video.mp4";

export default {
  name: "VideoSection",
  data() {
    return {
      videoSrc,
      tags: ["温", "补", "固"],
    };
  },
};
</script>

<style lang="scss" scoped>
.video-section {
  margin-bottom: 40px;
}

.video-frame {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  background: #000;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.video-player {
  display: block;
  width: 100%;
  min-height: 360px;
  object-fit: cover;
  max-height: 68vw;
}

.video-badges {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 12px;
  pointer-events: none;
}

.badge {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #e02e2e;
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.video-broadcast {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;
  pointer-events: none;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.45) 0%,
    rgba(0, 0, 0, 0) 100%
  );
}

.mark {
  font-size: 20px;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  font-weight: 500;
}
</style>
